<div
  class="kr-transactions"
  [formGroup]="filtersForm"
  data-testid="transactions_root">
  <div class="kr-transactions__header" data-testid="transactions_header">
    @if (!isolated()) {
      <div
        class="kr-transactions__header-title"
        data-testid="transactions_header_title">
        <h1
          class="kr-transactions__header-title-text"
          data-testid="transactions_title_text">
          {{ 'transactions.title' | translate }}
        </h1>
        <div
          class="kr-transactions__header-actions"
          data-testid="transactions_header_actions">
          <button
            type="button"
            fuButton
            size="s"
            uiType="secondary"
            data-testid="transactions_btn_monthly_report"
            (click)="openMonthlyReportDialog('report')">
            <fu-icon
              iconName="document"
              size="16"
              data-testid="transactions_icon_document" />
            {{ 'transactions.btn.monthlyRep' | translate }}
          </button>

          <button
            type="button"
            fuButton
            size="s"
            uiType="secondary"
            [disabled]="disabledReset"
            data-testid="transactions_btn_save_operations"
            (click)="saveOperations('download')">
            <fu-icon
              iconName="document"
              size="16"
              data-testid="transactions_icon_document_save" />
            {{ 'transactions.btn.saveOperations' | translate }}
          </button>

          <button
            type="button"
            fuButton
            size="s"
            uiType="secondary"
            data-testid="transactions_btn_toggle_filters"
            (click)="toggleFilters()">
            <fu-icon
              iconName="filters"
              size="16"
              data-testid="transactions_icon_filters" />
            {{
              (areFiltersShown()
                ? 'transactions.header.hideFilters'
                : 'transactions.header.showFilters'
              ) | translate
            }}
          </button>

          <button
            type="button"
            fuButton
            size="s"
            uiType="secondary"
            [disabled]="disabledReset"
            data-testid="transactions_btn_reset_filters"
            (click)="resetFilters()">
            <fu-icon
              iconName="reset"
              size="16"
              data-testid="transactions_icon_reset" />
            {{ 'transactions.btn.resetFilters' | translate }}
          </button>
        </div>
      </div>
    }
    @if (areFiltersShown()) {
      <div
        class="kr-transactions__header-filters"
        data-testid="transactions_filters">
        <fu-period-calendar
          [formControl]="dateRangeControl"
          [label]="'transactions.filters.date' | translate"
          [placeholder]="'transactions.filters.date.placeholder' | translate"
          data-testid="transactions_filter_date" />

        <fu-simple-input
          formControlName="comment"
          iconName="search"
          [placeholder]="'transactions.filters.comment.placeholder' | translate"
          [label]="'transactions.filters.comment.label' | translate"
          data-testid="transactions_filter_comment" />

        <kr-search-select
          [control]="statusControl"
          [placeholder]="'fu.select.placeholder' | translate"
          [label]="'transactions.filters.status' | translate"
          [items]="transactionStatuses()"
          [withSearch]="false"
          [multi]="true"
          data-testid="transactions_filter_status" />

        <kr-search-select
          [control]="operationControl"
          [placeholder]="'fu.select.placeholder' | translate"
          [label]="'transactions.filters.operationType' | translate"
          [items]="transactionTypes()"
          [withSearch]="false"
          [multi]="true"
          data-testid="transactions_filter_operation_type" />

        @if (!wallet() && wallets()?.length) {
          <kr-search-select
            [control]="providerIdControl"
            [placeholder]="'fu.select.placeholder' | translate"
            [label]="'transactions.filters.providerType' | translate"
            [items]="providerTypes()"
            [withSearch]="false"
            [multi]="false"
            data-testid="transactions_filter_provider_type" />

          <kr-search-select
            [control]="walletIdControl"
            [placeholder]="'fu.select.placeholder' | translate"
            [label]="'transactions.filters.wallet' | translate"
            [items]="filteredWallets()"
            [multi]="true"
            [searchByFields]="['id']"
            data-testid="transactions_filter_wallet" />
        }

        @if (!wallet() && coins().length) {
          <fu-select
            formControlName="coinId"
            [items]="coins()"
            [placeholder]="'fu.select.placeholder' | translate"
            [label]="'transactions.filters.currency' | translate"
            data-testid="transactions_filter_currency" />

          <button
            class="fu-form-btn apply-filters-btn"
            type="button"
            fuButton
            size="m"
            uiType="secondary"
            (click)="applyFilters()"
            [disabled]="!filtersForm.touched && !dateRangeControl.touched"
            data-testid="transactions_btn_apply_filters"
            translate="transactions.btn.applyFilters"></button>
        }
      </div>
    }
  </div>

  @if (transactions()?.length) {
    <ul
      class="kr-table__header kr-transactions__table-header"
      fuSort
      formControlName="sort"
      data-testid="transactions_table_header">
      @for (name of columnNames; track name) {
        <li
          class="kr-table__column"
          [class.kr-table__column_center]="name === 'comment'"
          [class.kr-table__column_end]="name === 'fee' || name === 'netFee'"
          [attr.data-testid]="'transactions_table_header_col' + name">
          @if (sortColumnIndex[name]) {
            <fu-sort
              [colName]="name"
              [withDefaultIcon]="true"
              [attr.data-testid]="'transactions_sort' + name"
              (click)="sortChange()">
              {{ 'transactions.column.' + name | translate }}
            </fu-sort>
          } @else {
            {{ 'transactions.column.' + name | translate }}
          }
        </li>
      }
    </ul>

    <ul class="kr-table__body" data-testid="transactions_table_body">
      @for (transaction of transactions(); track transaction.id) {
        <li
          class="kr-table__row"
          krTransaction
          [transaction]="transaction"
          [isolated]="isolated()"
          [wallet]="wallet()"
          [attr.data-testid]="'transactions_table_row' + transaction.id"
          (click)="openTransactionDetailsDialog(transaction)"></li>
      }
    </ul>
  } @else if (!isLoading()) {
    <fu-empty
      iconName="wallet"
      titleKey="transactions.empty.title"
      data-testid="transactions_empty"
      secondaryBtnLink />
  }
</div>

@if (itemsCount() > filters().limit) {
  <mat-paginator
    [length]="itemsCount()"
    [pageSize]="filters().limit"
    [showFirstLastButtons]="true"
    [pageSizeOptions]="[30, 50, 100]"
    [hidePageSize]="true"
    [pageIndex]="filters().page - 1"
    data-testid="transactions_paginator"
    (page)="changePage($event)"
    aria-label="Select page">
  </mat-paginator>
}
